interface Choice<T extends string> {
  value: T;
  label: string;
}

interface ChoiceGroupProps<T extends string> {
  name: string;
  legend: string;
  value: T | undefined;
  choices: readonly Choice<T>[];
  required?: boolean;
  error?: string;
  onChange: (value: T) => void;
}

export function ChoiceGroup<T extends string>({
  name,
  legend,
  value,
  choices,
  required,
  error,
  onChange,
}: ChoiceGroupProps<T>) {
  const errorId = `${name}-error`;
  return (
    <fieldset
      className="space-y-2"
      aria-describedby={error ? errorId : undefined}
      aria-invalid={Boolean(error)}
    >
      <legend className="field-label mb-2">
        {legend}
        {required ? <span className="text-crimson"> *</span> : null}
      </legend>
      <div className="grid gap-2 sm:grid-cols-3">
        {choices.map((choice) => (
          <label
            key={choice.value}
            className={`choice-chip ${value === choice.value ? 'choice-chip-selected' : ''}`}
          >
            <input
              className="sr-only"
              type="radio"
              name={name}
              value={choice.value}
              checked={value === choice.value}
              onChange={() => onChange(choice.value)}
            />
            {choice.label}
          </label>
        ))}
      </div>
      {error ? (
        <p className="text-sm font-semibold text-crimson" id={errorId} role="alert">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
}
